module.exports = __webpack_public_path__ + "img/pixing_xc9.8c734a81.jpg";